module.exports = __webpack_public_path__ + "static/great_desktop-06051dde4a724322f3aa6ad9bdeea7fe.jpg";